
    <h2>CAMPUS DEVELOPMENT</h2>
    
    
    
    <div style="width:910px; height:370px">
    
        <div class="ImageGallery10"><img id="ctl00_Image4" class="lightbox" href="../../../assets/images/Campus/Big/C1.jpg" src="../../../assets/images/Campus/C1.jpg" alt="Humanities &amp; Social Sciences Faculty Office"></div>
        <div class="ImageGallery10"><img id="ctl00_Image1" class="lightbox" href="../../../assets/images/Campus/Big/C2.jpg" src="../../../assets/images/Campus/C2.jpg" alt="Confucius Institute Computer Room"></div>
        <div class="ImageGallery10"><img id="ctl00_Image2" class="lightbox" href="../../../assets/images/Campus/Big/C3.jpg" src="../../../assets/images/Campus/C3.jpg" alt="Social Sciences School Office"></div>
        <div class="ImageGallery10"><img id="ctl00_Image3" class="lightbox" href="../../../assets/images/Campus/Big/C4.jpg" src="../../../assets/images/Campus/C4.jpg" alt="Lecture Theatre University of Adelaide"></div>
        <div class="ImageGallery10"><img id="ctl00_Image5" class="lightbox" href="../../../assets/images/Campus/Big/C5.jpg" src="../../../assets/images/Campus/C5.jpg" alt="Kaplan Melbourne Reception"></div><br>
        <div class="ImageGallery10"><img id="ctl00_Image6" class="lightbox" href="../../../assets/images/Campus/Big/C6.jpg" src="../../../assets/images/Campus/C6.jpg" alt="University Senior College Waiting Area"></div>
        <div class="ImageGallery10"><img id="ctl00_Image7" class="lightbox" href="../../../assets/images/Campus/Big/C7.jpg" src="../../../assets/images/Campus/C7.jpg" alt="Kaplan Sydney"></div>
        <div class="ImageGallery10"><img id="ctl00_Image8" class="lightbox" href="../../../assets/images/Campus/Big/C8.jpg" src="../../../assets/images/Campus/C8.jpg" alt="Faculty of Sciences Reception"></div>
        <div class="ImageGallery10"><img id="ctl00_Image9" class="lightbox" href="../../../assets/images/Campus/Big/C9.jpg" src="../../../assets/images/Campus/C9.jpg" alt="Kaplan Adelaide Reception "></div>
        <div class="ImageGallery10"><img id="ctl00_Image10" class="lightbox" href="../../../assets/images/Campus/Big/C10.jpg" src="../../../assets/images/Campus/C10.jpg" alt="Music Media Computer Room"></div>
    
    </div>
    
    <div>
               <span class="Highlight">Salt Studio</span> offers a consultation service to the Education industry to 
            assist in the establishment of new schools and higher ed colleges, and also the 
            redesign and streamlining of existing institutions. The team includes expertise in 
            marketing, facilities planning, design and building, and curriculum management &amp; development. 
            For over 15 years Salt Studio has completed successful Education projects throughout Australia for clients including the 
            <br><br>
    </div>
    
    <div style="width:50%;float:left" class="Highlight">
               
               The University of Adelaide<br>		
                University Senior College	<br>		
                Kaplan Australia 		<br>		
    </div>
    <div style="width:50%;float:right" class="Highlight">
               
               Bradford College<br>
               Grange College<br>
               Kaplan Business School<br>
    </div>
    
    
    
    